import React, { useState } from 'react'
import { Modal } from '@material-ui/core'
import 'style/ModalWarning.css'

class ModalWarning extends React.Component {
    state = {
        open: false,
        data: {}
    }

    handleOnClose = () => this.setState({ open: false })

    openModal = data => this.setState({ open: true, data: data || {} })

    render() {
        return (
            <Modal
                open={this.state.open}
                onClose={this.handleOnClose}
                className="modal-alert"
            >
                <div className="modal-alert__box">
                    <div className="modal-alert__content">
                        <p id="transition-modal-description">کاربر گرامی لطفاً برای استفاده از تمامی قابلیت های اپلیکیشن، از مرورگر chrome استفاده نمائید.</p>
                    </div>
                    <div className="modal-alert__btn-box">
                        <button className="modal-alert__cancel-btn" onClick={this.handleOnClose}>متوجه شدم</button>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default ModalWarning